/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HeroBannerDto } from '../../models/hero-banner-dto';

export interface HeroBannerControllerFindExposedV1$Params {

/**
 * 출처 필터
 */
  sourceType?: 'MILLIONSHOW' | 'GOODSPACE' | 'ALLHOUSE' | 'STARTFAIR' | 'AGRITEX' | 'GIFTFAIR';
}

export function heroBannerControllerFindExposedV1(http: HttpClient, rootUrl: string, params?: HeroBannerControllerFindExposedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<HeroBannerDto>> {
  const rb = new RequestBuilder(rootUrl, heroBannerControllerFindExposedV1.PATH, 'get');
  if (params) {
    rb.query('sourceType', params.sourceType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HeroBannerDto>;
    })
  );
}

heroBannerControllerFindExposedV1.PATH = '/api/v1/hero-banner';
